import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { BeaconMessageType, PermissionScope } from '..';
import { getAccountIdentifier } from '../utils/get-account-identifier';
/**
 * @internalapi
 *
 * The PermissionValidator is used to check if permissions for a certain message type have been given
 */

export var PermissionValidator = /*#__PURE__*/function () {
  function PermissionValidator() {
    _classCallCheck(this, PermissionValidator);
  }

  _createClass(PermissionValidator, null, [{
    key: "hasPermission",
    value:
    /**
     * Check if permissions were given for a certain message type.
     *
     * PermissionRequest and BroadcastRequest will always return true.
     *
     * @param message Beacon Message
     */
    function hasPermission(message, getOne, getAll) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var accountIdentifier, permission, permissions, filteredPermissions;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = message.type;
                _context.next = _context.t0 === BeaconMessageType.PermissionRequest ? 3 : _context.t0 === BeaconMessageType.BroadcastRequest ? 3 : _context.t0 === BeaconMessageType.OperationRequest ? 4 : _context.t0 === BeaconMessageType.SignPayloadRequest ? 13 : 20;
                break;

              case 3:
                return _context.abrupt("return", true);

              case 4:
                _context.next = 6;
                return getAccountIdentifier(message.sourceAddress, message.network);

              case 6:
                accountIdentifier = _context.sent;
                _context.next = 9;
                return getOne(accountIdentifier);

              case 9:
                permission = _context.sent;

                if (permission) {
                  _context.next = 12;
                  break;
                }

                return _context.abrupt("return", false);

              case 12:
                return _context.abrupt("return", permission.scopes.includes(PermissionScope.OPERATION_REQUEST));

              case 13:
                _context.next = 15;
                return getAll();

              case 15:
                permissions = _context.sent;
                filteredPermissions = permissions.filter(function (permission) {
                  return permission.address === message.sourceAddress;
                });

                if (!(filteredPermissions.length === 0)) {
                  _context.next = 19;
                  break;
                }

                return _context.abrupt("return", false);

              case 19:
                return _context.abrupt("return", filteredPermissions.some(function (permission) {
                  return permission.scopes.includes(PermissionScope.SIGN);
                }));

              case 20:
                throw new Error('Message not handled');

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }
  }]);

  return PermissionValidator;
}();